import { Action as RouterAction } from 'router';
import { Action as AssetsAction } from 'sections/assets';
import { Action as CampaignsAction } from 'sections/campaigns';
import { Action as ClientsAction } from 'sections/client-management';
import { DataAction } from '../services';
import { Action as TestAction } from '../test/actions';
import { UIAction } from '../core/ui';

// Create a Start Application Action
export const APPLICATION_START = 'APPLICATION_START';
interface ApplicationStartAction {
  type: 'APPLICATION_START';
}
export const startApplication = (): ApplicationStartAction => ({ type: APPLICATION_START });

// Combine Actions to create a global set of possible actions.
export type Action =
  | RouterAction
  | AssetsAction
  | CampaignsAction
  | ClientsAction
  | DataAction
  | TestAction
  | UIAction
  | ApplicationStartAction;
